class BirthdaySub extends HTMLElement {
	connectedCallback() {
		this.subcriptionType = this.getAttribute("data-subscription-type");
		this.initElements();
		this.initEvents();
	}

	initElements() {
		this.submitButton = this.querySelector("[data-birthday-subscription-button]");
		this.birthdayField = this.querySelector("[data-birthday-field]");
		this.birthdayField2 = this.querySelector("[data-birthday-field-2]");
		this.birthdayFieldError = this.querySelector("[data-birthday-field-error]");
		this.birthdayField2Error = this.querySelector("[data-birthday-field-2-error]");
		this.fieldWrappers = this.querySelectorAll(".birthday-subscription__field-wrapper");
		this.collectMessages = this.querySelector("[data-collect-form-status-message]");
	}

	initEvents() {
		this.submitButton.addEventListener("click", (event) => {
			event.preventDefault();

			this.sendData();
		});
	}

	sendData() {
		this.birthdayFieldError?.classList.add("hidden");
		this.birthdayField2Error.classList.add("hidden");

		if (this.subcriptionType === "duo" && !this.birthdayField.value) {
			this.birthdayFieldError.classList.remove("hidden");
			return null;
		}

		if (!this.birthdayField2.value) {
			this.birthdayField2Error.classList.remove("hidden");
			return null;
		}

		const ticket = new URL(document.location.href).searchParams.get("ticket");

		if (!ticket) {
			return null;
		}

		const customerData = {
			customer: {
				authenticationTicket: ticket,
				birthDate: this.birthdayField.value || null,
				customFields: {}
			}
		}

		if (this.birthdayField2.value) {
			customerData.customer.customFields.hPfriend = this.birthdayField2.value;
		}

		mindbox("async", {
			operation: "Unidragon.AddDateByTokenEU",
			data: customerData,
			onSuccess: this.onSuccess()
		});
	}

	onSuccess() {
		if (this.collectMessages) {

			this.fieldWrappers.forEach(fieldWrapper => {
				fieldWrapper.classList.add("hidden");
			})

			this.collectMessages.classList.remove("hidden");
			this.collectMessages.classList.add("success");

			this.collectMessages.innerHTML = "Form submit successfully"
		}

		if (this.submitButton){
			this.submitButton.disabled = true;
		}
	}
}

if (!customElements.get("birthday-sub")) {
	customElements.define("birthday-sub", BirthdaySub)
}
